import React from 'react';

import TrackingContext from './TrackingContext';

export default function useTrackingEvents() {
	return React.useContext(TrackingContext);
}
